export interface Toast {
  id: string
  message: string
  type: 'success' | 'error' | 'info'
}

let toastId = 0
const toasts: Toast[] = []
const listeners = new Set<(toasts: Toast[]) => void>()

function notifyListeners() {
  listeners.forEach((listener) => listener([...toasts]))
}

export function addToast(message: string, type: Toast['type'] = 'info') {
  const id = `toast-${toastId++}`
  toasts.push({ id, message, type })
  notifyListeners()

  setTimeout(() => {
    removeToast(id)
  }, 5000)
}

function removeToast(id: string) {
  const index = toasts.findIndex((toast) => toast.id === id)
  if (index > -1) {
    toasts.splice(index, 1)
    notifyListeners()
  }
}

export function subscribeToToasts(listener: (currentToasts: Toast[]) => void): () => void {
  listeners.add(listener)
  listener([...toasts])

  return () => {
    listeners.delete(listener)
  }
}
